
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?-autoprefixer&sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-328e629d\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./View.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./View.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-328e629d\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./View.vue"),
  /* scopeId */
  "data-v-328e629d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/client/pages/View.vue
// module id = 556
// module chunks = 1